<template>
  
  <v-card>
     <v-card-title>
       <v-icon x-large>mdi-xbox-controller-menu</v-icon>
       <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Filtro"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
    :headers="headers"
    :items="RepOrderTemplate"
    :search="search"
    sort-by="calories"
    class="elevation-1"
  >
    <template v-slot:top>
      <v-toolbar flat color="white">
        <v-spacer></v-spacer>
        <v-dialog v-model="dialog" max-width="900px">
          <!--<template v-slot:activator="{ on }">
            <v-btn color="primary" dark class="mb-2" v-on="on">New Item</v-btn>
          </template>-->
          <v-card>
            <div v-if="loading">
                <v-progress-linear  color="secondary" height="6" indeterminate rounded></v-progress-linear>
            </div>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-form
                  ref="form"
                  v-model="valid"
                  lazy-validation
                >
                <v-text-field type="number" v-model="editedItem.RepOrderTemplate_id" variant="solo-filled" 
                increment="1"   label="Status Id" required readonly v-show="false"></v-text-field>

                <v-row>
                  <v-col cols="12" md="4">
                     <v-text-field v-model="editedItem.RepOrderTemplate_Desc" :rules="descRules" label="Plantilla Desc"
                              variant="solo-filled" required></v-text-field>
                  </v-col> 
                </v-row>
                <v-row>
                  <v-col class="shrink" style="min-width: 220px;">
                    <v-autocomplete v-model="editedItem.RepOrderProcess_id"
                      :items="RepOrderProcess"
                      :item-text="'RepOrderProcess_Desc'"
                      :item-value="'RepOrderProcess_id'"
                      label="Selecciona un Proceso"
                      ></v-autocomplete>
                  </v-col>
                 </v-row>
                 <v-row>
                  <v-col>
                    <div>
                        <!-- Lista de etiquetas arrastrables -->
                        <div class="d-flex mb-2" style="gap: 8px;">
                          <v-chip
                            v-for="tag in availableTags"
                            :key="tag"
                            draggable="true"
                            @dragstart="onDragStart(tag)"
                            color="primary"
                            class="ma-1"
                          >
                            {{ tag }}
                          </v-chip>
                        </div>

                        <!-- Área de texto que acepta etiquetas -->
                        <v-textarea
                          v-model="editedItem.RepOrderTemplate_Text"
                          label="Escriba su texto y Arrastra etiquetas aquí"
                          auto-grow
                          outlined
                          @drop.prevent="onDrop"
                          @dragover.prevent
                        />
                      </div>
                  </v-col>
                 </v-row>
                </v-form>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="close">Cancel</v-btn>
              <v-btn :disabled="!valid" color="accent" text @click="save">Guardar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialog_new" max-width="900px">
          <template v-slot:activator="{ on }">
            <v-btn color="accent" dark class="mb-2" v-on="on">NUEVA PLANTILLA</v-btn>
          </template>
          <v-card>
            <div v-if="loading">
                <v-progress-linear  color="secondary" height="6" indeterminate rounded></v-progress-linear>
            </div>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-form
                  ref="form"
                  v-model="valid"
                  lazy-validation
                >
                <v-text-field type="number" v-model="editedItem.RepOrderTemplate_id" variant="solo-filled" 
                increment="1"   label="Status Id" required readonly v-show="false" :value="RepOrderTemplateId"></v-text-field>

                <v-row>
                  <v-col cols="12" md="4">
                     <v-text-field v-model="editedItem.RepOrderTemplate_Desc" :rules="descRules" label="Staus Desc"
                              variant="solo-filled" required></v-text-field>
                  </v-col> 
                </v-row>
                <v-row>
                  <v-col class="shrink" style="min-width: 220px;">
                    <v-autocomplete v-model="editedItem.RepOrderProcess_id"
                      :items="RepOrderProcess"
                      :item-text="'RepOrderProcess_Desc'"
                      :item-value="'RepOrderProcess_id'"
                      label="Selecciona un Proceso"
                      ></v-autocomplete>
                  </v-col>
                 </v-row>
                 <v-row>
                  <v-col>
                    <div>
                        <!-- Lista de etiquetas arrastrables -->
                        <div class="d-flex mb-2" style="gap: 8px;">
                          <v-chip
                            v-for="tag in availableTags"
                            :key="tag"
                            draggable="true"
                            @dragstart="onDragStart(tag)"
                            color="primary"
                            class="ma-1"
                          >
                            {{ tag }}
                          </v-chip>
                        </div>

                        <!-- Área de texto que acepta etiquetas -->
                        <v-textarea
                          v-model="editedItem.RepOrderTemplate_Text"
                          label="Escriba su texto y Arrastra etiquetas aquí"
                          auto-grow
                          outlined
                          @drop.prevent="onDrop"
                          @dragover.prevent
                        />
                      </div>
                  </v-col>
                 </v-row>
                </v-form>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="close">Cancel</v-btn>
              <v-btn :disabled="!valid" color="accent" text @click="save">Guardar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>
    <template v-slot:item.RepOrderTemplate_Color="{ item }">
      <v-chip :border="`${item.RepOrderTemplate_Color} thin opacity-10`"  :color="item.RepOrderTemplate_Color" :text="item.RepOrderTemplate_Color"
      size="small">{{ item.RepOrderTemplate_Color }}</v-chip>
    </template>
    
    <template v-slot:item.action="{ item }">
      <v-icon
        small
        class="mr-2"
        @click="editItem(item)"
      >
        mdi-pencil
      </v-icon>
      <v-icon
        small
        @click="deleteItem(item)"
      >
        mdi-delete
      </v-icon>
    </template>
    <template v-slot:no-data>
      <v-btn color="accent" @click="initialize">Reset</v-btn>
    </template>
  </v-data-table>
  </v-card>
</template>

<script>
import axios from 'axios'
export default {
  data: () => ({
    search: '',
    api_tool_url: process.env.VUE_APP_API_TOOL_URL,
    dialog: false,
    dialog_pass: false,
    dialog_new: false,
    loading: false,
    valid: true,
    availableTags: ['Usuario_Prov', 'Usuario_Logistico', 'Prov_Madre', 'Folio'],
    draggedTag: '',
    maxId: '',
		mask: '!#XXXXXXXX',
		menu: false,
    headers: [
      { text: 'Id Plantilla', key: 'RepOrderTemplate_id',value: 'RepOrderTemplate_id' },
      { text: 'Plantilla Desc', key: 'RepOrderTemplate_Desc',value: 'RepOrderTemplate_Desc' },
      { text: 'Id Proceso', key:'RepOrderProcess_id',value: 'RepOrderProcess_id' },
      { text: 'Proceso Desc', key:'RepOrderProcess_Desc',value: 'RepOrderProcess_Desc' },
      { text: 'Fecha Creación', key: 'RepEvent_Dt',value: 'RepEvent_Dt' },
      { text: 'Actions', value: 'action', sortable: false }
    ],
    RepOrderProcess: [],
    token: sessionStorage.getItem('access_token'),
    users: sessionStorage.getItem('ApiUser_id'),
    hora: '',
    fechaHoy: new Date().toISOString().split('T')[0],
    RepOrderTemplate: [],
    editedIndex: -1,
    editedItem: {
      RepOrderTemplate_id: '',
      RepOrderTemplate_Desc: '',
      RepOrderProcess_id: '',
      RepOrderTemplate_Text: '',
      RepEvent_id: '',
      LastOpRepUser_id: '',
      RepEvent_Dt: '',
      RepEvent_Tm: ''
    },
    defaultItem: {
      RepOrderTemplate_id: '',
      RepOrderTemplate_Desc: '',
      RepOrderProcess_id: '',
      RepOrderTemplate_Text: '',
      RepEvent_id: '',
      LastOpRepUser_id: '',
      RepEvent_Dt: '',
      RepEvent_Tm: ''
    },
    idRules: [
      v => !!v || 'Rol ID es requerido',
      v => (v && v.length <= 30) || 'Role ID debe tener menos de 30 caracteres',
    ],
    descRules: [
      v => !!v || 'Descripcion es requerida',
      v => (v && v.length <= 61) || 'Descripcion debe tener menos de 30 caracteres',
    ],
    config: {
      headers: {
        //'Authorization': 'Bearer ' + sessionStorage.getItem('access_token'),
        "api-user": sessionStorage.getItem('ApiUser_id')
      }
    }
  }),

  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'Nueva Plantilla' : 'Editar Plantilla'
    },
    swatchStyle() {
      const color = this.editedItem.RepOrderTemplate_Color
      const menu = this.menu
      return {
        backgroundColor: color,
        cursor: 'pointer',
        height: '30px',
        width: '30px',
        borderRadius: menu ? '50%' : '4px',
        transition: 'border-radius 200ms ease-in-out'
      }
    }
  },

  watch: {
    dialog (val) {
      val || this.close()
    },
  },

  created () {
    this.initialize()
  },

  methods: {
    initialize () {
      axios.post(this.api_tool_url + '/get_RepOrderTemplate', {}, this.config)
      .then(response => {
        this.RepOrderTemplate = response.data.ResultRows
      })
      .catch(error => {
        this.RepOrderTemplate = []
        alert(error.response.data.message)
      })

      axios.post(this.api_tool_url + '/get_RepOrderProcess', {}, this.config)
      .then(response => {
        this.RepOrderProcess = response.data.ResultRows
      })
      .catch(error => {
        this.RepOrderProcess = []
        alert(error.response.data.message)
      })
      
    },

    onDragStart(tag) {
      this.draggedTag = tag;
    },
    onDrop() {
      // Insertar la etiqueta donde está el cursor o al final
      this.editedItem.RepOrderTemplate_Text += (this.editedItem.RepOrderTemplate_Text ? ' ' : '') + `{${this.draggedTag}}`;
      this.draggedTag = '';
    },

    newtItem (item) {
      this.editedIndex = this.RepOrderTemplate.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog_new = true
    },

    editItem (item) {
      this.editedIndex = this.RepOrderTemplate.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },

    deleteItem (item) {
      const index = this.RepOrderTemplate.indexOf(item)
      confirm('¿Confirma la eliminación del registro?') && this.deleteUserMenu(index)
    },

    deleteUserMenu(index) {
      let usermenus_tmp = this.RepOrderTemplate[index]
      delete usermenus_tmp.RepOrderProcess_Desc
      delete usermenus_tmp.RepDbObject_id
      axios.post(this.api_tool_url + '/del_RepOrderTemplate', usermenus_tmp, this.config)
        .then(response => {
          this.RepOrderTemplate.splice(index, 1)
          this.close()
          })
        .catch(error => {
          this.RepOrderTemplate = []
          alert(error.response.data.message)
          })
    },

    close () {
      this.dialog = false
      this.dialog_new = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },

    save () {
      const ahora = new Date();
      const horas = ahora.getHours().toString().padStart(2, '0');
      const minutos = ahora.getMinutes().toString().padStart(2, '0');
      const segundos = ahora.getSeconds().toString().padStart(2, '0');
      this.hora = `${horas}:${minutos}:${segundos}`;

      delete this.editedItem.RepOrderProcess_Desc
      delete this.editedItem.RepDbObject_id

      this.editedItem.RepEvent_id = this.token
      this.editedItem.RepEvent_Dt = this.fechaHoy
      this.editedItem.LastOpRepUser_id = this.users
      this.editedItem.RepEvent_Tm = this.hora
      this.loading = true
      if (this.editedIndex > -1) {
        
        axios.post(this.api_tool_url + '/upd_RepOrderTemplate', this.editedItem, this.config)
        .then(response => {
          Object.assign(this.RepOrderTemplate[this.editedIndex], response.data.ResultRows[0])
          this.close()
          this.loading = false
          })
        .catch(error => {
          this.RepOrderTemplate = []
          this.loading = false
          alert(error.response.data.message)
          })
        //Object.assign(this.users[this.editedIndex], this.editedItem)
      } else {
        
        axios.post(this.api_tool_url + '/get_RepOrderTemplateId', {}, this.config)
        .then(response => {
          this.editedItem.RepOrderTemplate_id = response.data.ResultRows.RepOrderTemplateId

          axios.post(this.api_tool_url + '/ins_RepOrderTemplate', this.editedItem, this.config)
          .then(response => {
            //console.log(response)
            this.RepOrderTemplate.push(response.data.ResultRows[0])
            this.close()
            this.loading = false
          })
          .catch(error => {
            this.RepOrderTemplate = []
            this.loading = false
            alert(error.response.data.message)
          })


        })
        .catch(error => {
          this.RepOrderTemplate = []
          this.loading = false
          alert(error.response.data.message)
        })
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/RepOrderTemplateGrid.vue